<template>
  <div/>
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

const store = useStore<RootState>();

defineOptions({
  name: 'dataPricePairs',
});

// Базовый тип для сообщений с индексом пары
type PricePairWithIndex = {
  indexPair: number;
};

// Типы для WebSocket сообщений компонента pricePairs
type PricePairsListMessage = WebSocketMessageWithFields<'store-exchange-info' | 'store-info' | 'store-sync', {
  pricePairs: unknown[];
}>;
type PricePairCreateMessage = WebSocketMessageWithFields<'store-price-pair-create', PricePairWithIndex & {
  indexExchange: number;
  indexCurrencyPrimary: number;
  indexCurrencySecondary: number;
  offset: number;
  timeStart: number;
  valid: boolean;
}>;
type PricePairUpdateOffsetMessage = WebSocketMessageWithFields<'price-pair-update-offset', PricePairWithIndex & {
  offset: number;
}>;
type PricePairUpdateTimeStartMessage = WebSocketMessageWithFields<'price-pair-update-time-start', PricePairWithIndex & {
  timeStart: number;
}>;
type PricePairUpdateTimeStoreMessage = WebSocketMessageWithFields<'price-pair-update-time-store', PricePairWithIndex & {
  timeStore: number;
}>;
type PricePairUpdateValidMessage = WebSocketMessageWithFields<'price-pair-update-valid', PricePairWithIndex & {
  valid: boolean;
}>;

// Объединенный тип для всех сообщений
type PricePairsWebSocketMessage = 
  | PricePairsListMessage 
  | PricePairCreateMessage 
  | PricePairUpdateOffsetMessage 
  | PricePairUpdateTimeStartMessage 
  | PricePairUpdateTimeStoreMessage 
  | PricePairUpdateValidMessage;

// WebSocket message handler
const handleWebSocketMessage = (data: PricePairsWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'store-exchange-info':
    case 'store-info':
    case 'store-sync':
      store.dispatch('pricePairs/wsSetPricePairs', {
        pricePairs: data.pricePairs,
      });
      break;

    case 'store-price-pair-create':
      store.dispatch('pricePairs/wsPricePairCreate', {
        indexPair: data.indexPair,
        indexExchange: data.indexExchange,
        indexCurrencyPrimary: data.indexCurrencyPrimary,
        indexCurrencySecondary: data.indexCurrencySecondary,
        offset: data.offset,
        timeStart: data.timeStart,
        valid: data.valid,
      });
      break;

    case 'price-pair-update-offset':
      // Старый storage не реализовано

      // Новый storage
      store.dispatch('pricePairs/wsPricePairUpdate', {
        indexPair: data.indexPair,
        offset: data.offset,
      });
      break;

    case 'price-pair-update-time-start':
      store.dispatch('pricePairs/wsPricePairUpdate', {
        indexPair: data.indexPair,
        timeStart: data.timeStart,
      });
      break;

    case 'price-pair-update-time-store':
      store.dispatch('pricePairs/wsPricePairTimeStore', {
        indexPair: data.indexPair,
        timeStore: data.timeStore,
      });
      break;

    case 'price-pair-update-valid':
      store.dispatch('pricePairs/wsPricePairUpdate', {
        indexPair: data.indexPair,
        valid: data.valid,
      });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);
</script>
